"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryDraw = void 0;
var HistoryDrawList_1 = require("./HistoryDrawList");
var HistoryDraw = /** @class */ (function () {
    function HistoryDraw(data) {
        this.id = data.id;
        this.name = data.name;
        this.draw = data.draw;
        this.start = data.start;
        this.end = data.end;
        this.totalPrizeAmount = data.totalPrizeAmount;
        this.drawDateConverted = null;
        this.startDateConverted = null;
        this.endDateConverted = null;
    }
    HistoryDraw.JsonToDraws = function (data) {
        var drawsHistoryList = new HistoryDrawList_1.HistoryDrawList();
        data.forEach(function (draw) {
            if (!drawsHistoryList.map(function (x) { return x.id; }).includes(draw.id)) {
                drawsHistoryList.push(HistoryDraw.JsonToDraw(draw));
            }
        });
        return drawsHistoryList.getDrawDateConverted();
    };
    HistoryDraw.JsonToDraw = function (data) { return new HistoryDraw(data); };
    return HistoryDraw;
}());
exports.HistoryDraw = HistoryDraw;
//# sourceMappingURL=HistoryDraw.js.map